export default "__VITE_ASSET__WbEgmV5s__"